class CountdownTimer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initCountdown();
  }

  initCountdown() {
    const clockDiv = this.querySelector('.clockDiv'); // Locate the clockDiv element

    if (!clockDiv) {
      console.error('clockDiv element not found inside countdown-timer');
      return;
    }

    // Extract attributes from the clockDiv element
    const cutoffDate = clockDiv.getAttribute('data-countdown-cuttoff-date');
    const cutoffTime = clockDiv.getAttribute('data-countdown-cuttoff-time');
    const endMessage = clockDiv.getAttribute('data-countdown-end-message');

    // Combine date and time into a single deadline
    const deadlineDateTime = new Date(`${cutoffDate}T${cutoffTime}`);

    if (isNaN(deadlineDateTime.getTime())) {
      console.error('Invalid countdown deadline');
      return;
    }

    this.initializeClock(clockDiv, deadlineDateTime, endMessage);
  }

  initializeClock(clock, endtime, endMessage) {
    const daysSpan = clock.querySelector('.days');
    const hoursSpan = clock.querySelector('.hours');
    const minutesSpan = clock.querySelector('.minutes');
    const secondsSpan = clock.querySelector('.seconds');
    const clockWrapper = clock.querySelector('.clockDivWrapper');
    const headingElement = clock.querySelector('.countdown-timer__header');
    const endMessageElement = clock.querySelector('.clockDiv-end-message');

    const getTimeRemaining = (endtime) => {
      const now = new Date();
      const total = Date.parse(endtime) - now.getTime();
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));

      return {
        total,
        days,
        hours,
        minutes,
        seconds,
      };
    };

    const updateClock = () => {
      const t = getTimeRemaining(endtime);

      if (t.total <= 0) {
        // Timer has expired
        clearInterval(timeInterval);

        // Hide countdown elements
        if (clockWrapper) clockWrapper.style.display = 'none';
        if (headingElement) headingElement.style.display = 'none';

        // Show the end message if available
        if (endMessageElement) endMessageElement.style.display = 'block';

        return;
      }

      // Update the countdown display
      daysSpan.textContent = t.days;
      hoursSpan.textContent = ('0' + t.hours).slice(-2);
      minutesSpan.textContent = ('0' + t.minutes).slice(-2);
      secondsSpan.textContent = ('0' + t.seconds).slice(-2);
    };

    // Ensure timeInterval is initialized before updating the clock
    const timeInterval = setInterval(updateClock, 1000); // Update every second
    updateClock(); // Initialize immediately
  }
}

// Define the custom element
window.customElements.define('countdown-timer', CountdownTimer);
